import styled from "styled-components";

export const JackpotBetWidgetShadowOverlayDefaultBox = styled.div`
  pointer-events: none;
  height: 100%;
  position: absolute;
  inset: 0;
  z-index: 10;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  display: none;
`;
